// ---- NATUR BLUR · datos mock (frontend) ----

export const IMAGES = {
  street: "https://images.unsplash.com/photo-1579653384681-c3ba17c4a8c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  vlogger: "https://images.pexels.com/photos/4793182/pexels-photo-4793182.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  moto: "https://images.unsplash.com/photo-1572452571879-3d67d5b2a39f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  periodista: "https://images.pexels.com/photos/6950231/pexels-photo-6950231.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  concesionario: "https://images.unsplash.com/photo-1692406069831-0bb7ea297645?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  aula: "https://images.unsplash.com/photo-1577896851231-70ef18881754?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  camara: "https://images.unsplash.com/photo-1549109926-58f039549485?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const SAMPLE_VIDEO = {
  url: "https://videos.pexels.com/video-files/2053100/2053100-sd_640_360_30fps.mp4",
  name: "video-de-muestra.mp4",
};

/* ================= CRÉDITOS (localStorage) ================= */
const CREDITS_KEY = "naturblur_credits";
export const getCredits = () => {
  const v = localStorage.getItem(CREDITS_KEY);
  return v === null ? 25 : parseInt(v, 10);
};
export const setCredits = (n) => {
  localStorage.setItem(CREDITS_KEY, String(Math.max(0, n)));
  window.dispatchEvent(new Event("naturblur-credits"));
};
export const addCredits = (n) => setCredits(getCredits() + n);

/* ================= CONFIGURACIÓN BACKOFFICE (on/off) ================= */
const CONFIG_KEY = "naturblur_config";

export const DEFAULT_CONFIG = {
  menus: { editor: true, mediateca: true, herramientas: true, casos: true, tarifas: true, ayuda: true },
  header: { idioma: true, creditos: true, ctaEditor: true },
  sections: {
    hero: true, stats: true, herramientas: true, comoFunciona: true,
    casos: true, tarifas: true, testimonios: true, faq: true, ctaFinal: true,
  },
  footer: { visible: true },
};

export const getConfig = () => {
  try {
    const raw = localStorage.getItem(CONFIG_KEY);
    if (!raw) return JSON.parse(JSON.stringify(DEFAULT_CONFIG));
    const saved = JSON.parse(raw);
    return {
      menus: { ...DEFAULT_CONFIG.menus, ...(saved.menus || {}) },
      header: { ...DEFAULT_CONFIG.header, ...(saved.header || {}) },
      sections: { ...DEFAULT_CONFIG.sections, ...(saved.sections || {}) },
      footer: { ...DEFAULT_CONFIG.footer, ...(saved.footer || {}) },
    };
  } catch {
    return JSON.parse(JSON.stringify(DEFAULT_CONFIG));
  }
};

export const saveConfig = (cfg) => {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(cfg));
  window.dispatchEvent(new Event("naturblur-config"));
};

export const resetConfig = () => {
  localStorage.removeItem(CONFIG_KEY);
  window.dispatchEvent(new Event("naturblur-config"));
};

/* ================= NAVEGACIÓN ================= */
export const NAV_ITEMS = [
  { id: "editor", label: "Editor", to: "/editor" },
  { id: "mediateca", label: "Mediateca", to: "/mediateca" },
  {
    id: "herramientas", label: "Herramientas",
    dropdown: [
      { label: "Difuminar caras", desc: "Seguimiento fotograma a fotograma" },
      { label: "Difuminar matrículas", desc: "Ideal para dashcam y calle" },
      { label: "Fondo desenfocado", desc: "Efecto bokeh sin pantalla verde" },
      { label: "Difuminar objetos", desc: "Marca cualquier cosa y la IA la sigue" },
      { label: "Anonimizar con emoji", desc: "Cubre rostros con un toque divertido" },
    ],
  },
  {
    id: "casos", label: "Casos de uso",
    dropdown: [
      { label: "Creadores de contenido", desc: "Publica sin exponer a nadie" },
      { label: "Empresas y flotas", desc: "Cumple el RGPD sin esfuerzo" },
      { label: "Centros educativos", desc: "Protege la imagen del alumnado" },
      { label: "Videovigilancia", desc: "Comparte grabaciones con seguridad" },
    ],
  },
  { id: "tarifas", label: "Tarifas", to: "/tarifas" },
  {
    id: "ayuda", label: "Ayuda",
    dropdown: [
      { label: "Preguntas frecuentes", desc: "Resuelve tus dudas al momento" },
      { label: "Guías rápidas", desc: "Aprende a usar el editor" },
      { label: "Contacto", desc: "Escríbenos, respondemos rápido" },
    ],
  },
];

/* ================= OPCIONES DE DIFUMINADO (editor) ================= */
export const BLUR_OPTIONS = [
  { id: "faces", label: "Personas", desc: "Difuminado ovalado de rostros y cabezas", icon: "ScanFace" },
  { id: "plates", label: "Matrículas", desc: "Recuadro discreto del color del coche sobre la placa", icon: "Car" },
  { id: "bg", label: "Fondo", desc: "Desenfoque bokeh, el sujeto queda nítido", icon: "Focus" },
  { id: "emoji", label: "Emoji", desc: "Sustituye caras y cabezas por emojis", icon: "Smile" },
  { id: "both", label: "Personas + Matrículas", desc: "Protección total en un solo paso", icon: "ShieldCheck" },
  { id: "manual", label: "Manual asistido · Dakota", desc: "Vídeo limpio: tú enseñas a Dakota y ella sigue el objeto", icon: "MousePointerClick", isNew: true },
];

/* ================= HERRAMIENTAS (home) ================= */
export const TOOLS = [
  { icon: "ScanFace", name: "Difuminar caras", tag: "Popular", desc: "Rostros ocultos automáticamente, incluso en movimiento." },
  { icon: "Car", name: "Difuminar matrículas", tag: "Rápido", desc: "Perfecto para vídeos de conducción y vía pública." },
  { icon: "Focus", name: "Fondo desenfocado", tag: "IA", desc: "Bokeh profesional sin pantalla verde ni edición manual." },
  { icon: "Scan", name: "Difuminar objetos", tag: "", desc: "Señala cualquier elemento y la IA lo sigue en todo el clip." },
  { icon: "Smile", name: "Emoji sobre caras", tag: "Nuevo", desc: "Anonimiza con estilo: emojis que siguen cada rostro." },
  { icon: "Mic", name: "Anonimizar voz", tag: "Próximamente", desc: "Enmascara voces para proteger identidades al completo." },
];

/* ================= CÓMO FUNCIONA ================= */
export const STEPS = [
  { num: "1", icon: "UploadCloud", title: "Sube tu vídeo", desc: "Arrastra tu archivo MP4, MOV o M4V. Todo se procesa de forma segura." },
  { num: "2", icon: "SlidersHorizontal", title: "Elige qué ocultar", desc: "Caras, matrículas, fondo u objetos. Con vista previa al instante." },
  { num: "3", icon: "Download", title: "Descarga y comparte", desc: "Tu vídeo protegido en alta calidad, listo para publicar donde quieras." },
];

/* ================= CASOS DE USO ================= */
export const USE_CASES = [
  { title: "Creadores de contenido", desc: "Graba en la calle y publica sin preocuparte por quién aparece en el plano.", img: "vlogger" },
  { title: "Motovloggers", desc: "Matrículas y caras ocultas en tus rutas, sin editar fotograma a fotograma.", img: "moto" },
  { title: "Periodismo", desc: "Protege fuentes y testigos manteniendo el contexto de la noticia.", img: "periodista" },
  { title: "Concesionarios", desc: "Publica vídeos de vehículos sin exponer matrículas ni datos de clientes.", img: "concesionario" },
  { title: "Centros educativos", desc: "Comparte eventos escolares protegiendo la imagen de cada alumno.", img: "aula" },
  { title: "Videovigilancia", desc: "Entrega grabaciones cumpliendo la normativa de protección de datos.", img: "camara" },
];

/* ================= TARIFAS (€) ================= */
export const PRICING_PLANS = [
  {
    name: "Básico", desc: "Para ediciones puntuales", price: "4,99",
    credits: 50,
    features: ["50 créditos (~50 s de vídeo)", "Todos los tipos de difuminado", "Sin marca de agua"],
  },
  {
    name: "Creador", desc: "Para creadores y equipos pequeños", price: "24,99", popular: true,
    credits: 250,
    features: ["250 créditos (~4 min de vídeo)", "Procesamiento prioritario", "Calidad hasta 4K"],
  },
  {
    name: "Empresa", desc: "Para proyectos de gran volumen", price: "89,99",
    credits: 1000,
    features: ["1.000 créditos (~16 min de vídeo)", "Procesamiento por lotes", "Soporte dedicado"],
  },
];

/* ================= ESTADÍSTICAS ================= */
export const STATS = [
  { value: "120K+", label: "Vídeos protegidos" },
  { value: "500K+", label: "Matrículas ocultas" },
  { value: "4,8/5", label: "Valoración media" },
  { value: "24 h", label: "Borrado automático" },
];

/* ================= TESTIMONIOS ================= */
export const TESTIMONIALS = [
  {
    quote: "Grabo rutas en moto cada semana y Natur Blur me ahorra horas: las matrículas desaparecen solas del vídeo.",
    initials: "CM", name: "Carlos Medina", role: "Motovlogger",
    featured: true,
  },
  {
    quote: "Publicamos vídeos de eventos escolares con total tranquilidad. Las familias lo agradecen muchísimo.",
    initials: "LG", name: "Lucía Gómez", role: "Coordinadora · Centro educativo",
  },
  {
    quote: "El desenfoque de fondo da un acabado muy profesional a nuestras demos de producto. Y sin pantalla verde.",
    initials: "JR", name: "Javier Ruiz", role: "Marketing · Startup",
  },
  {
    quote: "Entregamos grabaciones de seguridad cumpliendo la normativa en minutos, no en días.",
    initials: "AT", name: "Ana Torres", role: "Responsable de seguridad",
  },
];

/* ================= FAQ ================= */
export const FAQS = [
  { q: "¿Cómo funciona el difuminado con IA?", a: "La IA analiza tu vídeo, detecta caras, matrículas u objetos y les aplica un difuminado con seguimiento de movimiento, fotograma a fotograma, sin que tengas que hacer nada manualmente." },
  { q: "¿Qué formatos de vídeo puedo subir?", a: "Aceptamos MP4, MOV y M4V. En el plan gratuito puedes subir vídeos de hasta 500 MB y 5 minutos de duración." },
  { q: "¿Qué son los créditos y cómo se gastan?", a: "Cada segundo de vídeo procesado consume 1 crédito. Al registrarte recibes 25 créditos de regalo y puedes conseguir más desde la página de tarifas." },
  { q: "¿Mis vídeos están seguros?", a: "Sí. Los vídeos se procesan de forma segura y se eliminan automáticamente a las 24 horas. Nunca se almacenan de forma permanente ni se comparten con terceros." },
  { q: "¿Puedo difuminar objetos en movimiento?", a: "Sí, el seguimiento por IA mantiene el difuminado fijado al elemento aunque se mueva por la escena: coches, personas, documentos, pantallas..." },
  { q: "¿Funciona desde el móvil?", a: "Totalmente. Natur Blur es una herramienta web adaptada a móvil y tablet: sube, edita y descarga desde cualquier dispositivo sin instalar nada." },
];
